import React from 'react';
import { Form, Row, Col } from 'grab-ui';
import _get from 'lodash/get';
import {
  FIELD_NAME,
  ShopAddressSettingsModalContext,
} from '../../shop-address-settings-modal-context';
import AddressMap from './address-map';
import ContactPersonField from './contact-person-field';
import ContactNumberField from './contact-number-field';
import AddressSearchField from './address-search-field';
import AddressDetailField from './address-detail-field';
import LocationNotesField from './location-notes-field';
import styles from './shop-address-settings-form.less';

const ShopAddressSettingsForm = () => {
  const {
    form,
    formId,
    formInitialValues,
    pickUpAddress,
    isFormLoading,
    submitFormHandler,
    userInfo,
  } = React.useContext(ShopAddressSettingsModalContext);

  const { verified = false } = pickUpAddress;

  const [latlng, setLatlng] = React.useState({
    latitude: _get(formInitialValues.grabPoi, 'coordinates.latitude', 0),
    longitude: _get(formInitialValues.grabPoi, 'coordinates.longitude', 0),
  });

  const makeAddressSearchFieldInitialValue = React.useCallback(
    () =>
      verified
        ? formInitialValues.grabPoi
        : {
            keywords: formInitialValues.grabPoi.keywords,
            address: formInitialValues.grabPoi.address,
          },
    [verified, pickUpAddress, formInitialValues],
  );

  const selectAddressHandler = grabPoi => {
    setLatlng(grabPoi.latlng);
  };

  return (
    <div className={styles.ShopAddressSettingsForm}>
      <div className={styles.AddressMap}>
        <AddressMap latlng={latlng} />
      </div>
      <Form id={formId} className={styles.Form} onSubmit={submitFormHandler}>
        <Row type="flex" gutter={16}>
          <Col xs={24}>
            <p className={styles.AddressLabel}>
              {pickUpAddress.shopifyLocation.name}
            </p>
          </Col>
          <Col className={styles.mt16} xs={24} md={12}>
            <ContactPersonField
              id={FIELD_NAME.CONTACT_PERSON}
              initialValue={formInitialValues.contactName}
              disabled={isFormLoading}
              form={form}
            />
          </Col>
          <Col className={styles.mt16} xs={24} md={12}>
            <ContactNumberField
              id={FIELD_NAME.CONTACT_NUMBER}
              initialValue={formInitialValues.contactPhone}
              disabled={isFormLoading}
              form={form}
            />
          </Col>
          <Col className={styles.mt16} xs={24}>
            <AddressSearchField
              id={FIELD_NAME.ADDRESS}
              initialValue={makeAddressSearchFieldInitialValue()}
              userInfo={userInfo}
              onSelectAddress={selectAddressHandler}
              form={form}
            />
          </Col>
          <Col className={styles.mt16} xs={24}>
            <AddressDetailField
              id={FIELD_NAME.ADDRESS_DETAIL}
              initialValue={formInitialValues.addressDetail}
              disabled={isFormLoading}
              form={form}
            />
          </Col>
          <Col className={styles.mt16} xs={24}>
            <LocationNotesField
              id={FIELD_NAME.LOCATION_NOTES}
              initialValue={formInitialValues.locationNotes}
              disabled={isFormLoading}
              form={form}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ShopAddressSettingsForm;
